import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { SyncUserRolesResponseSchema } from "../response/SyncUserRolesResponse";

interface SyncUserRolesPayload {
    user_id: string;
    roles: string[];
}

const useSyncUserRoles = () => {
    return useMutation({
        mutationFn: async ({ user_id, roles }: SyncUserRolesPayload) => await privateApi.post(`/v4/user/${user_id}/sync-roles`, { roles }),
        onSuccess: async (response) => {
            try {
                const validationResult = SyncUserRolesResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid sync user roles data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error('Failed to sync user roles', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid sync user roles error format");
            } else {
                console.error(`Failed to sync user roles`, error);
                throw error;
            }
        }
    });
};

export default useSyncUserRoles;
